module.exports = __webpack_public_path__ + "static/img/9.2a24acc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/8/zh/9.png
// module id = adO9
// module chunks = 0